module.exports = __webpack_public_path__ + "img/smith-anderson-thumb.85b132bf.jpg";